var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceBigTaskscomponent = function SvgWorkspaceBigTaskscomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 3,
    fill: "#FAD156"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 12h9v1.5h-9V12Zm0 3h9v1.5h-9V15Zm0 4.5h6V18h-6v1.5Zm15.75-2.25-1.125-1.125-4.117 4.125L16.75 18l-1.125 1.125 3.383 3.375 5.242-5.25Z",
    fill: "#fff"
  })));
};
export default SvgWorkspaceBigTaskscomponent;